// Shared form input styles to ensure consistency and prevent white text issues

export const formInputClasses = {
  base: 'w-full px-3 py-2 text-left bg-white dark:bg-gray-800 border border-gray-300 dark:border-gray-600 rounded-lg shadow-xs text-gray-900 dark:text-white',
  focus:
    'focus:outline-hidden focus:ring-2 focus:ring-orange-500 dark:focus:ring-orange-400 focus:border-transparent',
  disabled:
    'disabled:bg-gray-50 dark:disabled:bg-gray-900 disabled:text-gray-500 dark:disabled:text-gray-400 disabled:cursor-not-allowed',
  hover: 'hover:bg-gray-50 dark:hover:bg-gray-700',
  size: {
    sm: 'text-sm',
    md: 'text-base',
  },
};

export const getInputClasses = (options?: {
  disabled?: boolean;
  size?: 'sm' | 'md';
  className?: string;
}) => {
  const { disabled = false, size = 'sm', className = '' } = options || {};

  return `${formInputClasses.base} ${formInputClasses.focus} ${
    disabled ? formInputClasses.disabled : formInputClasses.hover
  } ${formInputClasses.size[size]} ${className}`.trim();
};
